import { render, staticRenderFns } from "./AtlasDetails.vue?vue&type=template&id=70732a46&"
import script from "./AtlasDetails.vue?vue&type=script&lang=js&"
export * from "./AtlasDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports